import { useParams } from "react-router-dom";

import OptionsData from "./components/OptionsData";
import Header from "../components/Header";

function QuizOptionsPage() {
    const { courseId, lectureId, itemId, questionId } = useParams();
    let pagesLinks = [
        {
            name: "تفاصيل السؤال",
            link: `/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}/options`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },
        {
            name: "محتوي المحاضرات",
            link: `/admin/courses/${courseId}/lectures/${lectureId}`,
        },
        {
            name: "اسألة الأختبار",
            link: `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}`,
        },
    ];
    return (
        <>
            <Header
                pageName="تفاصيل الأختبار"
                pages={pagesLinks}
                className="text-2xl"
            />
            <OptionsData />
        </>
    );
}

export default QuizOptionsPage;
